// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yc-select-items {
  max-height: 40vh;
}
.yc-select-items_with-search {
  max-height: calc(40vh - 37px);
}
.yc-select-items_with-selected-title {
  max-height: calc(40vh - 32px);
}
.yc-select-items_with-apply-button {
  max-height: calc(40vh - 38px);
}
.yc-select-items_with-search.yc-select-items_with-apply-button {
  max-height: calc(40vh - 37px - 38px);
}
.yc-select-items_with-selected-title.yc-select-items_with-apply-button {
  max-height: calc(40vh - 32px - 38px);
}
.yc-select-items_without-virtualized {
  overflow-y: auto;
}
.yc-select-items_without-virtualized .yc-select-item-wrap {
  margin-top: 0;
}
.yc-select-items_without-virtualized .yc-select-item-wrap:first-child {
  margin-top: 4px;
}
.yc-select-items:not(.yc-select-items_without-virtualized) .yc-select-item-wrap {
  overflow: initial;
}
.yc-select-items_grouped .yc-select-item-wrap {
  margin-top: 0;
  margin-bottom: 0;
}
.yc-select-items_grouped .yc-select-item {
  padding-left: 32px;
}
.yc-select_mobile .yc-select-items_mobile {
  max-height: 55vh;
}
.yc-select-items__group-title {
  padding: 5px 0 0 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: var(--g-color-text-hint);
  box-sizing: border-box;
}
.yc-select-items__group-title:first-child {
  padding-top: 5px;
}
.yc-select-items__group-title:not(:first-child) {
  border-top: 1px solid var(--g-color-line-generic);
}
.yc-select-items__group-title ~ .yc-select-item-wrap {
  margin-top: 0;
}
.yc-select-items__prompt {
  padding: 10px 16px;
  color: var(--g-color-text-secondary);
}
.yc-select-items__prompt-button {
  display: flex;
  margin: 8px 0 2px;
}
.yc-select-items__prompt-button_retry {
  margin-right: 10px;
}
.yc-select-items__show-more-link {
  display: flex;
  align-items: center;
  padding-left: 12px;
}
.yc-select-items__loader {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 0;
}
.yc-select-items__buttons {
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/common/YCSelect/Items/Items.scss"],"names":[],"mappings":"AAKA;EACI,gBAAA;AAJJ;AAMI;EACI,6BAAA;AAJR;AAOI;EACI,6BAAA;AALR;AAQI;EACI,6BAAA;AANR;AASI;EACI,oCAAA;AAPR;AAUI;EACI,oCAAA;AARR;AAWI;EACI,gBAAA;AATR;AAWQ;EACI,aAAA;AATZ;AAYQ;EACI,eAAA;AAVZ;AAcI;EACI,iBAAA;AAZR;AAeI;EACI,aAAA;EACA,gBAAA;AAbR;AAgBI;EACI,kBAAA;AAdR;AAiBI;EACI,gBAAA;AAfR;AAkBI;EACI,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,+BAAA;EACA,sBAAA;AAhBR;AAkBQ;EACI,gBAAA;AAhBZ;AAmBQ;EACI,iDAAA;AAjBZ;AAqBI;EACI,aAAA;AAnBR;AAsBI;EACI,kBAAA;EACA,oCAAA;AApBR;AAuBI;EACI,aAAA;EACA,iBAAA;AArBR;AAsBQ;EACI,kBAAA;AApBZ;AAwBI;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;AAtBR;AAyBI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AAvBR;AA0BI;EACI,aAAA;AAxBR","sourcesContent":[".yc-select-items {\n  max-height: 40vh;\n}\n.yc-select-items_with-search {\n  max-height: calc(40vh - 37px);\n}\n.yc-select-items_with-selected-title {\n  max-height: calc(40vh - 32px);\n}\n.yc-select-items_with-apply-button {\n  max-height: calc(40vh - 38px);\n}\n.yc-select-items_with-search.yc-select-items_with-apply-button {\n  max-height: calc(40vh - 37px - 38px);\n}\n.yc-select-items_with-selected-title.yc-select-items_with-apply-button {\n  max-height: calc(40vh - 32px - 38px);\n}\n.yc-select-items_without-virtualized {\n  overflow-y: auto;\n}\n.yc-select-items_without-virtualized .yc-select-item-wrap {\n  margin-top: 0;\n}\n.yc-select-items_without-virtualized .yc-select-item-wrap:first-child {\n  margin-top: 4px;\n}\n.yc-select-items:not(.yc-select-items_without-virtualized) .yc-select-item-wrap {\n  overflow: initial;\n}\n.yc-select-items_grouped .yc-select-item-wrap {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.yc-select-items_grouped .yc-select-item {\n  padding-left: 32px;\n}\n.yc-select_mobile .yc-select-items_mobile {\n  max-height: 55vh;\n}\n.yc-select-items__group-title {\n  padding: 5px 0 0 16px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  color: var(--g-color-text-hint);\n  box-sizing: border-box;\n}\n.yc-select-items__group-title:first-child {\n  padding-top: 5px;\n}\n.yc-select-items__group-title:not(:first-child) {\n  border-top: 1px solid var(--g-color-line-generic);\n}\n.yc-select-items__group-title ~ .yc-select-item-wrap {\n  margin-top: 0;\n}\n.yc-select-items__prompt {\n  padding: 10px 16px;\n  color: var(--g-color-text-secondary);\n}\n.yc-select-items__prompt-button {\n  display: flex;\n  margin: 8px 0 2px;\n}\n.yc-select-items__prompt-button_retry {\n  margin-right: 10px;\n}\n.yc-select-items__show-more-link {\n  display: flex;\n  align-items: center;\n  padding-left: 12px;\n}\n.yc-select-items__loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 8px 0;\n}\n.yc-select-items__buttons {\n  display: flex;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
